<nb-card>

    <nb-card-header class="title-dialog">
        <h3 h3 style="color: white;">Creación de Usuario: {{nombreDeUsuario}}</h3>
    </nb-card-header>
    <nb-card-body>
        <form #altaUsuarioOperador='ngForm'>
            <!-- <p-dropdown required class="limited-selector" id="dropdownCli" placeholder="Cliente"
                [style]="{'width':'100%','margin-bottom':'10px', 'margin-top':'10px'}" [options]="clientes"
                [(ngModel)]="clienteSelected" [virtualScroll]="true" [itemSize]="31" [filter]="true">
            </p-dropdown> -->
            <p-dropdown required class="limited-selector" id="dropdownPerf" placeholder="Perfil"
                [style]="{'width':'100%','margin-bottom':'10px', 'margin-top':'10px'}" [options]="perfiles"
                [(ngModel)]="perfilSelected" [virtualScroll]="true" [itemSize]="31" [filter]="true" scrollHeight="100px"
                [ngModelOptions]="{standalone: true}">
            </p-dropdown>
            <mat-form-field class="altaLabel" style="width: 29%; margin-right: 1%;">
                <mat-label>Usuario</mat-label>
                <input matInput #usuarioInput type="text" [(ngModel)]="nombreDeUsuario" name="nombreDeUsuario">
            </mat-form-field>
            <mat-form-field class="altaLabel" style="width: 29%; margin-right: 1%;">
                <mat-label>Apellido</mat-label>
                <input matInput #ApeInput type="text" [(ngModel)]="apellido" name="apellido">
            </mat-form-field>
            <mat-form-field class="altaLabel" style="width: 29%; margin-right: 1%;">
                <mat-label>Nombre</mat-label>
                <input matInput #nombreInput type="" [(ngModel)]="nombre" name="nombre">
            </mat-form-field>
            <mat-form-field class="altaLabel" style="width: 30%; margin-right: 1%;">
                <mat-label>DNI</mat-label>
                <input matInput #dniInput type="number" min="0" [(ngModel)]="dni" name="dni">
            </mat-form-field>
            <mat-form-field class="altaLabel" style="width: 29%; margin-right: 1%;">
                <mat-label>Contraseña</mat-label>
                <input matInput #contraseniaInput [type]="getInputTypePw()" [(ngModel)]="contrasenia" name="contrasenia"
                    autocomplete="new-password">
                <button mat-button matSuffix mat-icon-button aria-label="show" (click)="toggleShowPassword()">
                    <mat-icon>{{getIconPw()}}</mat-icon>
                </button>
            </mat-form-field>
            <mat-form-field class="altaLabel" style="width: 29%; margin-right: 1%;">
                <mat-label>Repetir Contraseña</mat-label>
                <input matInput #REcontraseniaInput [type]="getInputTypeREPw()" [(ngModel)]="REcontrasenia"
                    name="REcontrasenia">
                <button mat-button matSuffix mat-icon-button aria-label="show" (click)="toggleShowREPassword()">
                    <mat-icon>{{getIconREPw()}}</mat-icon>
                </button>
            </mat-form-field>
            <mat-form-field class="altaLabel" style="width: 30%;">
                <mat-label>Correo Electrónico</mat-label>
                <input matInput #emailInput type="text" [(ngModel)]="email" name="email">
            </mat-form-field>
        </form>
    </nb-card-body>
    <nb-card-footer class="nuevousuarioCardFooter">
        <button nbButton *ngIf="!showSpinner" size="tiny" class="buttontz col-2 float-left margin-right"
            (click)="cerrarModal()">Cancelar</button>
        <div *ngIf="passValidator.passErrors" class="altaUsuarioErrors">
            <span *ngIf="contrasenia.length" class="checkPassword" (mouseover)='showPassTooltip = true'
                (mouseout)='showPassTooltip = false'>Verifica
                la contraseña</span>
            <div *ngIf="showPassTooltip" class="passwordTooltip">
                <h4>La contraseña debe contener: </h4>
                <span [ngClass]="contrasenia.length < 8 ? 'textErrors' : 'textErrorsOk'">
                    <mat-icon [ngClass]="contrasenia.length < 8 ? 'reqIconError' : 'reqIconOk'">
                        {{contrasenia.length < 8 ? 'highlight_off' : 'check_circle_outline' }} </mat-icon> Como
                            minimo 8 caracteres
                </span>
                <span [ngClass]="contrasenia.length > 15  ? 'textErrors' : 'textErrorsOk'">
                    <mat-icon [ngClass]="contrasenia.length > 15 ? 'reqIconError' : 'reqIconOk'">
                        {{contrasenia.length > 15 ?
                        'highlight_off' : 'check_circle_outline'}}
                    </mat-icon> Como maximo 15 caracteres
                </span>
                <span [ngClass]="passValidator.errorCapitalCase ? 'textErrors' : 'textErrorsOk'">
                    <mat-icon [ngClass]="passValidator.errorCapitalCase ? 'reqIconError' : 'reqIconOk'">
                        {{passValidator.errorCapitalCase ?
                        'highlight_off' : 'check_circle_outline'}}
                    </mat-icon> Al menos una mayúscula
                </span>
                <span [ngClass]="passValidator.errorLowerCase ? 'textErrors' : 'textErrorsOk'">
                    <mat-icon [ngClass]="passValidator.errorLowerCase ? 'reqIconError' : 'reqIconOk'">
                        {{passValidator.errorLowerCase ?
                        'highlight_off' : 'check_circle_outline'}}
                    </mat-icon> Al menos una minúscula
                </span>
                <span [ngClass]="passValidator.errorHasNumber ? 'textErrors' : 'textErrorsOk'">
                    <mat-icon [ngClass]="passValidator.errorHasNumber ? 'reqIconError' : 'reqIconOk'">
                        {{passValidator.errorHasNumber ?
                        'highlight_off' : 'check_circle_outline'}}
                    </mat-icon> Al menos un numero
                </span>
                <span [ngClass]="passValidator.errorPassNotMatch ? 'textErrors' : 'textErrorsOk'">
                    <mat-icon [ngClass]="passValidator.errorPassNotMatch ? 'reqIconError' : 'reqIconOk'">
                        {{passValidator.errorPassNotMatch ?
                        'highlight_off' : 'check_circle_outline'}}
                    </mat-icon> Las contraseñas <span *ngIf="passValidator.errorPassNotMatch">&nbsp;no&nbsp;</span>
                    coinciden
                </span>
            </div>
        </div>
        <app-spinner *ngIf="showSpinner"></app-spinner>
        <button nbButton *ngIf="!showSpinner" size="tiny" class="buttontz" (click)="saveUsuario()"
            [disabled]='passValidator.passErrors'>Guardar</button>
    </nb-card-footer>
</nb-card>